// This file is auto-generated by @hey-api/openapi-ts

import { type Options, getApiCommonShutdown, postApiCommonShutdown, getApiGameInit, postApiGameStart, postApiGameBet, postApiGameFastBet, postApiGameCashout, getApiGameCheck } from '../sdk.gen';
import { queryOptions, type UseMutationOptions, type DefaultError } from '@tanstack/react-query';
import type { GetApiCommonShutdownData, PostApiCommonShutdownData, PostApiCommonShutdownResponse, GetApiGameInitData, PostApiGameStartData, PostApiGameStartResponse, PostApiGameBetData, PostApiGameBetResponse, PostApiGameFastBetData, PostApiGameFastBetResponse, PostApiGameCashoutData, PostApiGameCashoutResponse, GetApiGameCheckData } from '../types.gen';
import { client as _heyApiClient } from '../client.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? _heyApiClient).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [
        params
    ];
};

export const getApiCommonShutdownQueryKey = (options?: Options<GetApiCommonShutdownData>) => createQueryKey('getApiCommonShutdown', options);

export const getApiCommonShutdownOptions = (options?: Options<GetApiCommonShutdownData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getApiCommonShutdown({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getApiCommonShutdownQueryKey(options)
    });
};

export const postApiCommonShutdownQueryKey = (options?: Options<PostApiCommonShutdownData>) => createQueryKey('postApiCommonShutdown', options);

export const postApiCommonShutdownOptions = (options?: Options<PostApiCommonShutdownData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postApiCommonShutdown({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postApiCommonShutdownQueryKey(options)
    });
};

export const postApiCommonShutdownMutation = (options?: Partial<Options<PostApiCommonShutdownData>>): UseMutationOptions<PostApiCommonShutdownResponse, DefaultError, Options<PostApiCommonShutdownData>> => {
    const mutationOptions: UseMutationOptions<PostApiCommonShutdownResponse, DefaultError, Options<PostApiCommonShutdownData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postApiCommonShutdown({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiGameInitQueryKey = (options: Options<GetApiGameInitData>) => createQueryKey('getApiGameInit', options);

export const getApiGameInitOptions = (options: Options<GetApiGameInitData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getApiGameInit({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getApiGameInitQueryKey(options)
    });
};

export const postApiGameStartQueryKey = (options?: Options<PostApiGameStartData>) => createQueryKey('postApiGameStart', options);

export const postApiGameStartOptions = (options?: Options<PostApiGameStartData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postApiGameStart({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postApiGameStartQueryKey(options)
    });
};

export const postApiGameStartMutation = (options?: Partial<Options<PostApiGameStartData>>): UseMutationOptions<PostApiGameStartResponse, DefaultError, Options<PostApiGameStartData>> => {
    const mutationOptions: UseMutationOptions<PostApiGameStartResponse, DefaultError, Options<PostApiGameStartData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postApiGameStart({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postApiGameBetQueryKey = (options?: Options<PostApiGameBetData>) => createQueryKey('postApiGameBet', options);

export const postApiGameBetOptions = (options?: Options<PostApiGameBetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postApiGameBet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postApiGameBetQueryKey(options)
    });
};

export const postApiGameBetMutation = (options?: Partial<Options<PostApiGameBetData>>): UseMutationOptions<PostApiGameBetResponse, DefaultError, Options<PostApiGameBetData>> => {
    const mutationOptions: UseMutationOptions<PostApiGameBetResponse, DefaultError, Options<PostApiGameBetData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postApiGameBet({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postApiGameFastBetQueryKey = (options?: Options<PostApiGameFastBetData>) => createQueryKey('postApiGameFastBet', options);

export const postApiGameFastBetOptions = (options?: Options<PostApiGameFastBetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postApiGameFastBet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postApiGameFastBetQueryKey(options)
    });
};

export const postApiGameFastBetMutation = (options?: Partial<Options<PostApiGameFastBetData>>): UseMutationOptions<PostApiGameFastBetResponse, DefaultError, Options<PostApiGameFastBetData>> => {
    const mutationOptions: UseMutationOptions<PostApiGameFastBetResponse, DefaultError, Options<PostApiGameFastBetData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postApiGameFastBet({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postApiGameCashoutQueryKey = (options?: Options<PostApiGameCashoutData>) => createQueryKey('postApiGameCashout', options);

export const postApiGameCashoutOptions = (options?: Options<PostApiGameCashoutData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postApiGameCashout({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postApiGameCashoutQueryKey(options)
    });
};

export const postApiGameCashoutMutation = (options?: Partial<Options<PostApiGameCashoutData>>): UseMutationOptions<PostApiGameCashoutResponse, DefaultError, Options<PostApiGameCashoutData>> => {
    const mutationOptions: UseMutationOptions<PostApiGameCashoutResponse, DefaultError, Options<PostApiGameCashoutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postApiGameCashout({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiGameCheckQueryKey = (options: Options<GetApiGameCheckData>) => createQueryKey('getApiGameCheck', options);

export const getApiGameCheckOptions = (options: Options<GetApiGameCheckData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getApiGameCheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getApiGameCheckQueryKey(options)
    });
};